import React, { useEffect } from "react";
import { API_BASE_URL } from "../config";
import { useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./PaymentCancel.css"; // Make sure to create this CSS file

const DebitSuccessFail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const transactionStatus = searchParams.get("TS");
  const packageId = sessionStorage.getItem("debit_package_id");

  useEffect(() => {
    const activateAndFetchPackage = async () => {
      try {
        const user = JSON.parse(sessionStorage.getItem("user"));
        const user_id = user?.payLoad?.user?.Id;
        if (user_id && packageId) {
          // Check if already activated
          const activatedFlag = sessionStorage.getItem("debit_package_activated");
          if (activatedFlag === packageId) {
            // Already activated, do nothing
            return;
          }
          // Activate package using fetch
          const response = await fetch(
            `${API_BASE_URL}/activate/package`,
            {
              method: "POST",
              body: JSON.stringify({
                user_id: user_id,
                package_id: packageId,
              }),
            }
          );
          const activateData = await response.json();
          if (activateData.statusCode === 1) {
            // Set flag so we don't activate again on refresh
            sessionStorage.setItem("debit_package_activated", packageId);
            // Fetch updated user packages
            const response = await fetch(
              `${API_BASE_URL}/user/package?user_id=${user_id}`
            );
            const data = await response.json();
            if (data.statusCode === 1) {
              const user = JSON.parse(sessionStorage.getItem("user"));
              user.payLoad.user.userPackages = data.payLoad;
              sessionStorage.setItem("user", JSON.stringify(user));
              window.dispatchEvent(new Event("userPackageUpdated"));
            }
          }
        }
      } catch (error) {
        console.error(
          "Error activating package or fetching user packages:",
          error
        );
      }
    };
    if (transactionStatus === "S") {
      activateAndFetchPackage();
    }
  }, [transactionStatus, packageId]);

  let content;
  if (transactionStatus === "S") {
    content = (
      <div className="payment-cancel-container">
        <img
          src="/payment-successful.png"
          alt="Payment Successful"
          className="cancel-image"
        />
        <h2>Payment Successful</h2>
        <p>Your payment was successful. Thank you!</p>
        <button className="home-button" onClick={() => navigate("/packages")}>
          Continue
        </button>
      </div>
    );
  } else {
    content = (
      <div className="payment-cancel-container">
        <img
          src="/paymentcancel.png"
          alt="Payment Cancelled"
          className="cancel-image"
        />
        <h2>Payment Failed</h2>
        <p>
          We're sorry to inform you that your payment has been unsuccessful.
        </p>
        <p>Please try again or contact support if you have questions.</p>
        <button className="home-button" onClick={() => navigate("/packages")}>
          Go Back
        </button>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      {content}
      <Footer />
    </>
  );
};

export default DebitSuccessFail;
